// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__1aPK6","consentsList":"PatientConsents_consentsList__ECGyG","consentsListEmpty":"PatientConsents_consentsListEmpty__3Z0Nj"};